<template>
  <div class="page service">
    <navigation
      arr-theme="white"
      :sticky="false"
      :theme="{background: 'transparent',color: '#fff'}"
    >联系客服</navigation>
    <div class="banner"></div>
    <div class="content">
      <h4 class="title">温馨提示</h4>
      <p class="sub-title">尊敬的用户，如果您在金融产品申请过程中遇到任何问题，请第一时间联系我们</p>
      <div class="qa-box">
        <div class="qa-title">
          以下问题，关注微信公众号<br>
          或联系客服，极速处理
        </div>
        <div class="qa-list">
          <div class="qa-item">查询借款进度</div>
          <div class="qa-item">查询还款进度</div>
          <div class="qa-item">建议或投诉</div>
        </div>
      </div>
      <div class="code-box">
        <div class="code-img">
          <!-- <img src="https://ndmicro-tmd.oss-cn-beijing.aliyuncs.com/TMD/assets/qr_code.png"> -->
          <img src="./images/img_QR@2x.png">
          <p class="code-text">微信公众号</p>
        </div>
        <div class="code-right">
          <div class="right-box right-download" @click="handleDownload">
            <p class="right-p1">点击下载二维码至相册</p>
            <p class="right-p2">微信扫一扫识别关注公众号</p>
          </div>
          <div class="right-box right-copy" @click="copy">
            <p class="right-p1">点击复制微信号 ct_tmd</p>
            <p class="right-p2">微信搜索关注公众号</p>
          </div>
        </div>
      </div>
      <div class="tips-box">
        如遇到诈骗等紧急情况，请勿相信！立即联系客服！<br>
        崇天客服热线：400-010-0008<br>
        服务监督热线：023-67561036
        <template v-if="showStyle !== 'NORMAL'">
          <div class="finance" v-if="financeOpen">
            如果您对平台有任何建议或投诉，也可通过以下方式进行反馈。<br>
            监督机构投诉渠道<br>
            南岸区金融办监督电话：023-62629122<br>
            <span class="grey">(工作日 上午9:00-12:30 下午14:00-18:00）</span><br>
            联络地址：重庆市南岸区茶园新城广福大道5号
          </div>

          <div class="open-container" @click="financeOpen = !financeOpen">
            {{financeOpen?'收起':'展开'}}
          <span class="icon arrow" :class="{financeOpen: !financeOpen}"></span></div>
        </template>
      </div>
      <div class="button" @click="serviceVisible = true">联系客服</div>
      <div v-if="showRefund" class="refund-box">
        <div class="refund-btn" @click="refundVisible = true">申请退款</div>
      </div>
    </div>
    <!-- 联系客服弹窗框 -->
    <nd-dialog v-model="serviceVisible" @confirm="callService" @close='closeDialog'>
      <div class="service-dialog">
        <div class="title">联系客服</div>
        <div class="description">拨打客服电话进行咨询</div>
        <div class="description1">客服电话：{{customerServicePhone}}</div>
        <div class="telphone">服务时间：</div>
        <div class="telphone">周一到周五 上午9:00-12:00 下午13:30-18:00</div>
      </div>
    </nd-dialog>
    <van-popup
      v-model="refundVisible"
      position="bottom"
      closeable
    >
      <div class="refund-main">
        <div class="refund-title">请选择退款会员卡</div>
        <div class="refund-content">
          <van-radio-group v-model="memberNo">
            <div 
              v-for="item in refundList" 
              :key="item.memberNo"
              class="refund-item"
              @click="memberNo = item.memberNo"
            >
              <div class="item-label">{{item.goodsName}}</div>
              <div class="item-radio">
                <van-radio :name="item.memberNo" checked-color="#ff3d2d"></van-radio>
              </div>
            </div>
          </van-radio-group>
        </div>
        <div class="refund-btn">
          <nd-button @click="hanldeJumpRefund">确认</nd-button>
        </div>
      </div>
    </van-popup>
    <service-jw v-model="serviceJwVisible"></service-jw>
  </div>
</template>

<script>
import { copyToClipbord, getKey, judgeClientSystem, mockHrefJump } from '../../../assets/utils'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
import { Popup, RadioGroup, Radio } from 'vant'
import { mapActions } from 'vuex'
import ServiceJw from '@/components/service-jw'

export default {
  data () {
    return {
      refundList: null,
      isIOS: judgeClientSystem() === 'IOS',
      customerServicePhone: '4000100008',
      serviceVisible: false,
      serviceJwVisible: false,
      refundVisible: false,
      memberNo: '',
      showRefund: false,
      financeOpen: false,
      showStyle: 'NORMAL'
    }
  },
  components: {
    ServiceJw,
    [Popup.name]: Popup,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio
  },
  created () {
    if (getKey('userInfo', 'token')) {
      this.queryMemberList()
      this.getCsShowStyle()
    }
    this.$bus.$emit('ready')
  },
  methods: {
    ...mapActions('refund', [
      'queryMemberListX'
    ]),
    ...mapActions('user', [
      'csShowStyle'
    ]),
    async getCsShowStyle () {
      const { success, data } = await this.csShowStyle()
      if (success) {
        this.showStyle = data.showStyle
      }
    },
    copy () {
      // copyToClipbord('gh_cf6437c25f46')
      copyToClipbord('ct_tmd')
      this.$message('已复制到剪贴板')
    },

    handleDownload () {
      this.downloadIamge('http://ndmicro-tmd.oss-cn-beijing.aliyuncs.com/authenticate/1_15683410918_Web_1605512702096', 'qrcode')
      // this.downloadIamge('https://ndmicro-tmd.oss-cn-beijing.aliyuncs.com/TMD/assets/qr_code.png', 'qrcode')
    },

    async downloadIamge (imgsrc, name) {
      this.$report({
        id: 10299,
        args: {
          screen: 'page_landing_yzd'
        }
      })
      if (hasNativeMethod('saveQRCode')) {
        const res = await jsBridge('saveQRCode', {
          url: imgsrc,
          name: name
        })
        if (res && res.code === 'OK') {
          this.saveSuccess()
        }
      } else if (this.isIOS) {
        this.$message('请长按左侧二维码保存')
      } else {
        let image = new Image()
        let self = this
        image.setAttribute('crossOrigin', 'anonymous')
        image.onload = function () {
          let canvas = document.createElement('canvas')
          canvas.width = image.width
          canvas.height = image.height
          let context = canvas.getContext('2d')
          context.drawImage(image, 0, 0, image.width, image.height)
          let url = canvas.toDataURL('image/png') // 得到图片的base64编码数据
          let a = document.createElement('a') // 生成一个a元素
          let event = new MouseEvent('click') // 创建一个单击事件
          a.download = name // 设置图片名称没有设置则为默认
          a.href = url // 将生成的URL设置为a.href属性
          a.dispatchEvent(event) // 触发a的单击事件
          self.saveSuccess()
        }
        image.src = imgsrc
      }
    },

    saveSuccess () {
      this.$message('已保存至系统相册')
    },
    callService () {
      this.$report({
        id: 10061, 
        args: {
          position: 'page_page_my',
          target: this.customerServicePhone
        }
      })
      mockHrefJump(`tel:${this.customerServicePhone}`)
    },
    closeDialog () {
      this.$report({
        id: 10062, 
        args: {
          postion: 'page_page_my'
        }
      })
    },
    // 获取会员列表
    async queryMemberList () {
      const { success, data } = await this.queryMemberListX()
      if (success) {
        this.refundList = data.refundMemberList
        if (this.refundList && this.refundList.length) {
          this.showRefund = true
          this.memberNo = this.refundList[0].memberNo
        }
      }
    },
    // 跳转至退款页面
    hanldeJumpRefund () {
      if (!this.memberNo) {
        return this.$message('请选择需要退款的会员卡')
      }
      const chosenRefund = this.refundList.find(item => item.memberNo === this.memberNo)
      if (chosenRefund && chosenRefund.supplier === 'JI_WEI') {
        this.refundVisible = false
        this.serviceJwVisible = true
        return
      }
      this.refundVisible = false
      const refundItem = this.refundList.find(item => item.memberNo === this.memberNo)
      let path = ''
      const query = {
        memberNo: this.memberNo
      }
      if (refundItem.refunding) {
        path = '/refund'
      } else {
        if (refundItem.refundWay === 'APPLY') {
          path = '/refund'
        } else {
          path = '/refund/service'
        }
      }
      this.$router.push({
        path,
        query
      })
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.service{
  background: linear-gradient(90deg, #BBC6FF 0%, #719AFF 100%);
  padding-bottom: 80px;
  height: auto;
  .banner{
    width: 100%;
    height: 544px;
    background: url(./images/img_bg@2x.png) center no-repeat;
    background-size: 100%;
    margin-top: -110px;
  }
  .content{
    padding: 10px 40px 0;
    color: #fff;
    .title{
      text-align: center;
      font-size: 36px;
      line-height: 75px;
      font-weight: 500;
    }
    .sub-title{
      text-align: center;
      font-size: 24px;
      line-height: 1.5;
    }
    .qa-box{
      background-color: #fff;
      border-radius: 30px;
      padding: 35px;
      margin-top: 30px;
      .qa-title{
        font-size: 32px;
        color: #333333;
        line-height: 1.5;
        font-weight: 500;
      }
      .qa-list{
        display: flex;
        flex-wrap: wrap;
        margin-top: 15px;
        .qa-item{
          width: 33.3333333%;
          color: #FDA81F;
          font-size: 22px;
          &::before{
            content: "";
            display: inline-block;
            width: 20px;
            height: 20px;
            border-radius: 50%;
            background-color: #FDA81F;
            margin-right: 10px;
          }
        }
      }
    }
    .code-box{
      margin-top: 20px;
      background-color: #fff;
      border-radius: 30px;
      padding: 40px 30px;
      display: flex;
      justify-content: space-between;
      color: #333333;
      .code-img{
        width: 160px;
        background-color: #F7F7F7;
        border-radius: 8px;
        padding: 10px;
        text-align: center;
        img{
          width: 140px;
          height: 140px;
        }
        .code-text{
          font-size: 20px;
          line-height: 28px;
          margin-top: 4px;
        }
      }
      .code-right{
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        width: 433px;
        .right-box{
          background-color: #F7F7F7;
          background-position: calc(100% - 20px) center;
          background-size: 30px;
          background-repeat: no-repeat;
          padding: 10px 30px;
          border-radius: 8px;
          .right-p1{
            font-size: 26px;
            font-weight: 500;
            line-height: 37px;
          }
          .right-p2{
            font-size: 20px;
            color: #9C9C9C;
            line-height: 28px;
          }
          &.right-download{
            background-image: url(./images/icon_download@2x.png);
          }
          &.right-copy{
            background-image: url(./images/icon_copy@2x.png);
          }
        }
      }
    }
  }
  .tips-box{
    background: linear-gradient(90deg, #1659FD 0%, #5C77FF 100%);
    padding: 37px 30px 37px 40px;
    border-radius: 30px;
    color: #fff;
    font-size: 24px;
    line-height: 33px;
    margin-top: 20px;
    .open-container {
      display: flex;
      text-align: center;
      align-items: center;
      justify-content: center;
      padding: 15px 0;
      color: #A9BEFF;
      font-size: 20px;
      margin-bottom: -30px;
    }

    .finance {
        margin-top: 20px;
       
      } 
      .grey {
        opacity: 0.8;
      }
    .icon.arrow {
      background-image: url(./images/img_arrow_b@2x.png);
      background-size: 18px 10px;
      background-repeat: no-repeat;
      display: block;
      width: 18px;
      height: 10px;
      margin-left: 5px;
      

      &.financeOpen {
        transform: rotateX(180deg);
      }
    }
  }
  .button{
    width: 630px;
    height: 94px;
    line-height: 94px;
    background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
    border-radius: 47px;
    font-size: 36px;
    font-weight: 500;
    text-align: center;
    margin: 40px auto 0;
   
  }
  .refund-box{
    display: flex;
    justify-content: center;
    margin-top: 22px;
    .refund-btn{
      font-size: 28px;
      color: #6B7CB2;
    }
  }
  .service-dialog {
    padding-top: 10px;
    padding: 0 48px;
    padding-bottom: 80px;
    font-family: PingFangSC-Regular,PingFang SC;

    .title {
      font-size: 42px;
      height: 72px;
      line-height: 72px;
      font-family: PingFangSC-Semibold,PingFang SC;
      font-weight: 600;
    }

    .description {
      font-size: 30px;
      height: 32px;
      line-height: 32px;
      margin-top: 22px;
      font-weight: 400;
    }
    .description1{
      font-size: 30px;
      height: 32px;
      line-height: 32px;
      margin: 12px auto 12px;
      font-weight: 400;
    }

    .telphone {
      font-size: 24px;
      height: 40px;
      line-height: 40px;
      margin-top: 2px;
      font-weight: 400;
      color: @fc3;
    }
  }
}
.refund-main{
  .refund-title{
    font-size: 36px;
    color: #333333;
    border-bottom: 1PX solid #eeeeee;
    padding: 50px;
    font-weight: bold;
  }
  .refund-content{
    .refund-item{
      display: flex;
      align-items: center;
      justify-content: space-between;
      border-bottom: 1PX solid #eeeeee;
      padding: 34px 50px;
      .item-label{
        font-size: 30px;
        color: #333333;
      }
      .item-radio{
        font-size: 36px;
        /deep/.van-radio__icon{
          font-size: 36px;
        }
      }
    }
  }
  .refund-btn{
    display: flex;
    justify-content: center;
    padding: 88px 0;
  }
}
/deep/.van-popup__close-icon{
  font-size: 40px;
  top: 53px;
  right: 50px;
}
</style>